/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React, { useState, useMemo, useEffect } from "react";

import { HashRouter, Switch, Route } from "react-router-dom";
import { bem } from "../shared/BEM";
import { MainSidebar } from "./MainSidebar";
import { ModelProvider } from "../providers/ModelProvider";
import { PageModel } from "./PageModel";
import { PageWelcome } from "./PageWelcome";
import { PageNotFound } from "./PageNotFound";

/**
 * Component props
 */
export interface IMainProps {
	modelProvider: ModelProvider;
}

/**
 * Main application component
 *
 * @param props Props
 */
export function Main (props: IMainProps) {

	const [ menuOpened, setMenuOpened ] = useState(false);

	const handleMenuToggle = useMemo(() => () => {
		setMenuOpened((state) => !state);
	}, []);

	useEffect(() => {

		const handleHashChange = () => {
			setMenuOpened(false);
		};

		window.addEventListener("hashchange", handleHashChange);

		return () => {
			window.removeEventListener("hashchange", handleHashChange);
		};

	}, []);

	const headerMods = [];

	if (menuOpened) {
		headerMods.push("menu-opened");
	}

	const style = bem("layout", "root");

	return (
		<HashRouter>
			<div className={style.className()}>
				{/* Responsive header */}
				<header className={style.el("header").mod(headerMods).className()}>
					<button
						className={style.el("header-btn-menu").className()}
						onClick={handleMenuToggle}
					><i className="mdi mdi-menu" /></button>
					<span className={style.el("header-title").className()}>VŠTE PIC - Neuronové sítě</span>
				</header>

				{/* Sidebar */}
				<MainSidebar modelProvider={props.modelProvider} opened={menuOpened} />

				{/* Contents */}
				<div className={style.el("contents").className()}>
					<Switch>
						<Route path="/models/:modelId" render={(params) =>
							<PageModel modelProvider={props.modelProvider} modelId={params.match.params.modelId} />
						} />
						<Route path="/" exact={true} component={PageWelcome} />
						<Route component={PageNotFound} />
					</Switch>
				</div>
			</div>
		</HashRouter>
	);

}
